'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clear = exports.publish = exports.subscribe = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

exports.publishSync = publishSync;

var _effects = require('redux-saga/effects');

var _ScreenKeyConst = require('../components/screen/ScreenKeyConst');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = [publishSync].map(_regenerator2.default.mark);

var bus = new _map2.default();

/**
 * sets a function to be called on the indicated lifecycle event
 * @param {string} event - lifecycle event to register for
 * @param {function} func - function to execute
 * @param {object} [args] - arguments to be passed to the function when called
 * @param {string} [screenKey] - screenKey to register this event under
 */
var subscribe = exports.subscribe = function subscribe(event, func) {
  var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var screenKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  // seed screenkey if missing
  if (!bus.has(screenKey)) {
    bus.set(screenKey, new _map2.default());
  }

  // seed array of events if needed
  if (!bus.get(screenKey).has(event)) {
    bus.get(screenKey).set(event, []);
  }

  bus.get(screenKey).get(event).push({ func: func, args: args });
};

/**
 * Dispatch the indicated lifecycle event
 * @param {string} event - the event
 * @param {object} [args] - arguments from the publisher to be merged with the subscriber args
 * @param {string} [screenKey] - the screen to fire the event for 
 */
var publish = exports.publish = function publish(event) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var screenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  // no events registered
  if (!bus.has(screenKey) || !bus.get(screenKey).has(event)) {
    return;
  }

  var events = bus.get(screenKey).get(event);
  for (var key in events) {
    if (!events.hasOwnProperty(key)) continue;

    var _event = events[key];

    _event.func((0, _assign2.default)({}, args, _event.args));
  }
};

/**
 * Dispatch the indicated lifecycle event synchronously and returns result.
 * @param {string} event - the event
 * @param {object} [args] - arguments from the publisher to be merged with the subscriber args
 * @param {string} [screenKey] - the screen to fire the event for 
 */
function publishSync(event) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var screenKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  var events, key, _event2, result;

  return _regenerator2.default.wrap(function publishSync$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(!bus.has(screenKey) || !bus.get(screenKey).has(event))) {
            _context.next = 2;
            break;
          }

          return _context.abrupt('return');

        case 2:
          events = bus.get(screenKey).get(event);
          _context.t0 = _regenerator2.default.keys(events);

        case 4:
          if ((_context.t1 = _context.t0()).done) {
            _context.next = 15;
            break;
          }

          key = _context.t1.value;

          if (events.hasOwnProperty(key)) {
            _context.next = 8;
            break;
          }

          return _context.abrupt('continue', 4);

        case 8:
          _event2 = events[key];
          _context.next = 11;
          return (0, _effects.call)(_event2.func, (0, _assign2.default)({}, args, _event2.args));

        case 11:
          result = _context.sent;
          return _context.abrupt('return', result);

        case 15:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked[0], this);
};

/**
 * Clear all events registered for the indicated screenKey
 * @param {string} [screenKey] 
 */
var clear = exports.clear = function clear() {
  var screenKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _ScreenKeyConst.ACTIVE_SCREEN_KEY;

  if (!bus.has(screenKey)) {
    return;
  }

  bus.get(screenKey).clear();
};


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/ModuleEventBusService.js
// module id = 221
// module chunks = 10